export default {"src":"/_next/static/media/user-check.c4318dcb.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};